import styled from '@emotion/styled';
import Typography from '@mui/material/Typography';
import { colors } from 'theme/colors';

export const StyledValueFormHeader = styled(Typography)`
  background: ${colors.primary15};
  height: min-content;
  font-size: 20px;
  border-radius: 4px;
  padding: 10px 20px;
  margin-left: -5px;
`;
